// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__29FZp","label":"CategoryService_label__24NUp","location":"CategoryService_location__1jf09"};